import { useState } from "react";
import { RefreshCw, Loader2 } from "lucide-react";
import { api, describeAxiosError, formatINR } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { incrementMonthLabel } from "./IncrementRecords";

export const RecalculateIncrementDialog = ({ record, onClose, onSaved }) => {
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const run = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try { const { data } = await api.post(`/increments/${record.id}/recalculate-payroll`); onSaved(data); }
    catch (e) { setError(describeAxiosError(e)); }
    finally { setBusy(false); }
  };
  return <AlertDialog open onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
    <AlertDialogContent className="bg-white w-[calc(100%-2rem)] rounded-lg" data-testid="increment-recalculate-dialog">
      <AlertDialogHeader><AlertDialogTitle data-testid="increment-recalculate-title">Recalculate {record.employee_name}’s payroll?</AlertDialogTitle>
        <AlertDialogDescription data-testid="increment-recalculate-description">Apply {formatINR(Math.round(record.new_ctc / 12))} monthly gross from {incrementMonthLabel(record.effective_month || record.effective_date)}. Saved paid days and manual deductions stay unchanged. Earlier months are not changed, and any later increments still apply in their own months.</AlertDialogDescription>
      </AlertDialogHeader>
      {error && <p role="alert" className="text-sm text-red-700" data-testid="increment-recalculate-error">{error}</p>}
      <AlertDialogFooter><AlertDialogCancel disabled={busy} data-testid="increment-recalculate-cancel">Cancel</AlertDialogCancel><Button onClick={run} disabled={busy} data-testid="increment-recalculate-confirm">{busy ? <Loader2 className="animate-spin" /> : <RefreshCw />}Recalculate payroll</Button></AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>;
};